import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleTextInputField } from '@warehouse/title/ui';

export function OriginalTitleField({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.originalTitle(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextInputField label="Original Title" path={path} />;
}
